import PropTypes from 'prop-types';

export default class ZipCodeInput extends React.Component {
  static propTypes = {
    wrapperClassName: PropTypes.string,
    zipCodeLabelWrapper: PropTypes.string,
    zipCodeInputWrapper: PropTypes.string,
    zipCodeName: PropTypes.string.isRequired,
  };

  static defaultProps = {
    wrapperClassName: '',
    zipCodeLabelWrapper: 'lg-3',
    zipCodeInputWrapper: 'lg-5'
  };

  constructor() {
    super();

    this.state = {error: ''};
    this.zipcodeRef = React.createRef();
  }

  componentDidMount = () => {
    $("select[name='country']").on('change', () => {
      this._validateZipCode();
    });
  };

  _validateZipCode = () => {
    const zipcode = this.zipcodeRef.current.value;
    const country = document.getElementsByName('country')[0].value;
    const regExp = {
      'US': /^(\d{5})[\s-]?(\d{4})?$/,
      'CA': /^([ABCEGHJKLMNPRSTVXY]\d[A-Za-z])[ -]?(\d[A-Za-z]\d)$/i
    };
    let error = '';

    if (zipcode && country in regExp && !regExp[country].test(zipcode)) {
      error = 'Enter a valid  postal / zip code';
    }
    if(error) {this.zipcodeRef.current.value = '';}
    this.setState({error});
  }

  render() {
    const {error} = this.state;
    const {wrapperClassName, zipCodeLabelWrapper, zipCodeInputWrapper, zipCodeName} = this.props;

    return (
      <div className={`${wrapperClassName} zipcode-input`}>
        <div className="row">
          <label className={`form-label xs-12 single-line ${zipCodeLabelWrapper}`}>
            Zip/Postal Code <span>*</span>
          </label>
          <div className={`control-wrapper ${zipCodeInputWrapper}`}>
            <input className="gcvZipField" type="text" id={`${zipCodeName}`} name={`${zipCodeName}`} onBlur={ this._validateZipCode } ref={this.zipcodeRef} required />
            {error && <label id={`${zipCodeName}-error`} className="font-bold" style={{color: 'red'}} htmlFor={`${zipCodeName}`}>
              {error}
            </label>}
          </div>
        </div>
      </div>
    );
  }
}
